function buildDonutOptions(series, labels) {
  return {
    colors: ["#1C7EBD", "#5EBAB4", "#7237BE", "#E9D2F4", "#B59194"],
    plotOptions: {
      pie: {
        dataLabels: { minAngleToShowLabel: 5 },
        donut: { size: "65%" }
      }
    },
    legend: { show: false },
    chart: { height: 380, width: "100%", type: "donut", fontFamily: "manrope" },
    series: series,
    labels: labels,
    tooltip: { y: { formatter: (value) => `${value} Downloads` } }
  };
}

function renderLegend(container, labels, series, colors) {
  if (!container) return;
  container.innerHTML = '';
  const total = series.reduce((sum, v) => sum + (Number(v) || 0), 0) || 0;
  const fmtPct = (raw) => {
    if (raw > 99) return '>99';
    if (raw < 1 && raw > 0) return '<1';
    return String(Math.round(raw));
  };
  let unknownValue = 0;
  let unknownColor;
  for (let j = 0; j < labels.length; j++) {
    const name = String(labels[j] || '').trim();
    const color = colors[j % colors.length];
    const val = Number(series[j] || 0);
    if (name.toLowerCase() === 'unknown') { unknownValue += val; unknownColor = color; continue; }
    const pct = total ? (val * 100.0 / total) : 0;
    container.insertAdjacentHTML('beforeend', `
      <div class="flex justify-between items-start gap-3 py-1">
        <div class="flex items-center min-w-0 flex-1">
          <span class="rounded-full h-5 w-5 flex-shrink-0 mr-3" style="background-color: ${color}"></span>
          <span class="min-w-0 break-words">${name}</span>
        </div>
        <div class="flex-shrink-0 whitespace-nowrap text-right">${val} (${fmtPct(pct)}%)</div>
      </div>
    `);
  }
  if (unknownValue > 0 && unknownColor) {
    const pct = total ? (unknownValue * 100.0 / total) : 0;
    container.insertAdjacentHTML('beforeend', `
      <div class="flex justify-between items-start gap-3 py-1">
        <div class="flex items-center min-w-0 flex-1">
          <span class="rounded-full h-5 w-5 flex-shrink-0 mr-3" style="background-color: ${unknownColor}"></span>
          <span class="min-w-0 break-words">Unknown</span>
        </div>
        <div class="flex-shrink-0 whitespace-nowrap text-right">${unknownValue} (${fmtPct(pct)}%)</div>
      </div>
    `);
  }
  try {
    if (container.SimpleBar && typeof container.SimpleBar.unMount === 'function') {
      container.SimpleBar.unMount();
    }
    new SimpleBar(container, { autoHide: false });
  } catch (_) {}
}

import { wireDatePicker } from "../../../../shared/date_picker";
import { downloadChartCsv } from "../../shared/csv_download";

document.addEventListener('alpine:init', () => {
  Alpine.data('PrefixBrowsersDonut', () => ({
    apiUrl: null,
    chart: null,
    init() {
      const root = this.$el || document;
      const wrapper = root.closest('[data-top-browsers-root]') || root;
      this.apiUrl = (wrapper?.dataset?.apiUrl) || '/analytics/chart';
      try {
        this.pickerApi = wireDatePicker({
          rootEl: this.$el || document,
          onChange: () => this.fetchAndRender(),
          inputSelector: '#browsers-range',
          buttonSelector: '#__none__',
          hiddenFromSelector: '#browsers_from',
          hiddenToSelector: '#browsers_to',
          maxDate: 'today',
          activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
        });
        const input = (this.$el || document).querySelector('#browsers-range');
        const clearBtn = (this.$el || document).querySelector('#browsers-clear');
        const fromEl = (this.$el || document).querySelector('#browsers_from');
        const toEl = (this.$el || document).querySelector('#browsers_to');
        const syncClear = () => {
          try { if (clearBtn) (input && input.value && input.value.trim()) ? clearBtn.classList.remove('hidden') : clearBtn.classList.add('hidden'); } catch (_) {}
        };
        if (input) { input.addEventListener('input', syncClear); input.addEventListener('change', syncClear); setTimeout(syncClear, 0); }
        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            try { if (input) input.value=''; if (fromEl) fromEl.value=''; if (toEl) toEl.value=''; } catch(_) {}
            syncClear();
            this.fetchAndRender();
          });
        }
      } catch (_) {}
      this.fetchAndRender();
      // CSV download
      const dlBtn = (this.$el || document).querySelector('#prefix-browsers-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            const params = new URLSearchParams();
            params.append('chart_type', 'audience_browser');
            try {
              const from = (this.$el || document).querySelector('#browsers_from')?.value;
              const to = (this.$el || document).querySelector('#browsers_to')?.value;
              if (from && to) {
                params.append('date_range', 'custom');
                params.append('start_date', from);
                params.append('end_date', to);
              } else {
                params.append('date_range', 'all_time');
              }
            } catch (_) { params.append('date_range', 'all_time'); }
            await downloadChartCsv({
              endpoint: this.apiUrl,
              params,
              filename: 'top_browsers.csv',
              columns: ['Browser', 'Downloads'],
              dataPath: 'download_data'
            });
          } catch (e) { console.error('browsers csv error', e); }
        });
      }
      window.addEventListener('turbo:before-cache', () => this.destroy());
    },
    destroy() {
      try { this.chart && this.chart.destroy && this.chart.destroy(); } catch (_) {}
      this.chart = null;
    },
    buildParams() {
      const params = new URLSearchParams();
      params.append('chart_type', 'audience_browser');
      try {
        const from = (this.$el || document).querySelector('#browsers_from')?.value;
        const to = (this.$el || document).querySelector('#browsers_to')?.value;
        if (from && to) {
          params.append('date_range', 'custom');
          params.append('start_date', from);
          params.append('end_date', to);
          return params;
        }
      } catch (_) {}
      params.append('date_range', 'all_time');
      return params;
    },
    async fetchAndRender() {
      const params = this.buildParams();
      try {
        const res = await fetch(`${this.apiUrl}?${params.toString()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
        if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
        const raw = await res.json();
        const data = (raw && raw.chart_data) ? raw.chart_data : raw;
        const labels = Array.isArray(data?.labels) ? data.labels : [];
        const series = Array.isArray(data?.series) ? data.series : [];
        const hasData = labels.length > 0 && series.length > 0;
        const pieEl = document.querySelector('#prefix-browsers-pie');
        const legendEl = document.querySelector('#prefix-browsers-legend');
        const noDataEl = document.querySelector('#prefix-browsers-no-data');
        if (!hasData) {
          if (pieEl) pieEl.innerHTML = '';
          if (legendEl) legendEl.innerHTML = '';
          if (noDataEl) noDataEl.removeAttribute('hidden');
          return;
        }
        if (noDataEl) noDataEl.setAttribute('hidden', '');
        const options = buildDonutOptions(series, labels);
        if (this.chart) { try { this.chart.destroy(); } catch (_) {} }
        this.chart = new ApexCharts(pieEl, options);
        this.chart.render();
        renderLegend(legendEl, labels, series, options.colors);
      } catch (e) { console.error('audience_browser donut fetch error', e); }
    }
  }));
});
